import { render, staticRenderFns } from "./InvalidateRecovery.vue?vue&type=template&id=0f732002&scoped=true"
import script from "./InvalidateRecovery.vue?vue&type=script&lang=js"
export * from "./InvalidateRecovery.vue?vue&type=script&lang=js"
import style0 from "./InvalidateRecovery.vue?vue&type=style&index=0&id=0f732002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f732002",
  null
  
)

export default component.exports